import { FC } from 'react';

import './PanelHeader.scss';

interface IProps {
  label: string;
  icon?: string;
  outlined?: boolean;
  onClose: () => void;
  backAction?: { label: string; onBack: () => void };
}

const PanelHeader: FC<IProps> = ({ label, icon, outlined, onClose, backAction }) => {
  return (
    <div className="PanelHeader">
      {backAction ? (
        <button className="PanelHeader-back" onClick={backAction.onBack} type="button">
          <span className="material-icons">chevron_left</span>
          <span>Back to all {backAction.label}</span>
        </button>
      ) : (
        <div className="PanelHeader-title">
          {icon ? (
            <span className={outlined ? 'material-icons-outlined' : 'material-icons'}>{icon}</span>
          ) : null}
          <span className="PanelHeader-label">{label}</span>
        </div>
      )}
      <button
        className="PanelHeader-close"
        onClick={onClose}
        aria-label="Close navigation panel"
        type="button"
      >
        <span className="material-icons">close</span>
      </button>
    </div>
  );
};

export default PanelHeader;
